import { render, staticRenderFns } from "./PageOpportunityEstimation.vue?vue&type=template&id=6e2134f7"
import script from "./PageOpportunityEstimation.vue?vue&type=script&lang=js"
export * from "./PageOpportunityEstimation.vue?vue&type=script&lang=js"
import style0 from "./PageOpportunityEstimation.vue?vue&type=style&index=0&id=6e2134f7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports